import React, { useEffect, useRef, useState } from "react";
import { BrowserMultiFormatReader } from "@zxing/browser";

const apiUrl = process.env.REACT_APP_BACKEND_URL



const DEFAULT_LENS_ID = "f8823014-8a95-40c6-a6c4-22ad1a182379";
const DEFAULT_GROUP_ID = "a0c7f4f8-6ace-4d41-9a3a-f7e4dc2d65bd"


export const getLensIdFromBarcode = async (barcode) => {
    try {
        const response = await fetch(`${apiUrl}/lens/${barcode}`);
        // const response = await fetch(`/lens/${barcode}`);

        if (!response.ok) {
            return {
                lensId: DEFAULT_LENS_ID,
                groupId: DEFAULT_GROUP_ID,
                lensName: null
            };
            // throw new Error("Barcode not found");
        }

        const data = await response.json();
        return {
            lensId: data.lens_id,
            groupId: data.group_id,
            lensName: data.lens_name
        };
    } catch (error) {
        console.error("Error fetching lens ID:", error);
        return {
            lensId: DEFAULT_LENS_ID,
            groupId: DEFAULT_GROUP_ID,
            lensName: null
        }
    }
};


const BarcodeSnapScanner_2 = () => {
    const [scannerActive, setScannerActive] = useState(false);
    const [userInteracted, setUserInteracted] = useState(false);
    const [scannedBarcodes, setScannedBarcodes] = useState(new Set());
    const [scannedBarcode, setScannedBarcode] = useState("");
    const [isScanningActive, setIsScanningActive] = useState(false);



    const videoRef = useRef(null);
    const barcodeStreamRef = useRef(null);


    const barcodeLensMapping = [
        { barcode: "9783827313591", lensId: "5e3d2c69-f8cb-49ea-976b-3cadc5bb2f9a" },
        // { barcode: "123456745650", lensId: "8dda0063-874a-4a71-a6fc-246447951f22" },
        { barcode: "123456745650", lensId: "fbb63483-3eea-468e-b905-549e7dbaa028" },
        { barcode: "8901435015879", lensId: "8dda0063-874a-4a71-a6fc-246447951f22" }
    ]



    const constraints = {
        video: {
            facingMode: "user",
            aspectRatio: 9 / 16,
            // width: "100%",
            // height: "100%",
            width: { ideal: 1280 },
            height: { ideal: 720 },
            frameRate: { ideal: 30 },
            objectFit: "cover",
            autoFocus: true,
            zoom: false,
            autoFocus: true,
        },
    }


    const startBarcodeScanner = async () => {
        try {
            // if (
            //     typeof navigator === "undefined" ||
            //     !navigator.mediaDevices ||
            //     typeof navigator.mediaDevices.getUserMedia !== "function"
            // ) {
            //     throw new Error("Camera API is not supported in this browser.");
            // }



            console.log("Requesting camera permissions...");

            const permissionStatus = await navigator.permissions.query({ name: "camera" });

            if (permissionStatus.state === "denied") {
                throw new Error("Camera permission is denied. Please enable it in browser settings.");
            }
            setScannerActive(true);


            const constraints = {
                video: {
                    facingMode: "user",
                    aspectRatio: 9 / 16,
                    // width: "100%",
                    // height: "100%",
                    width: { ideal: 1680 }, // 4K width
                    height: { ideal: 780 },
                    frameRate: { ideal: 30 },
                    objectFit: "cover",
                    autoFocus: true,
                    zoom: false,
                    autoFocus: true,
                },
            }
            const stream = await navigator.mediaDevices.getUserMedia(constraints);

            if (videoRef.current) {
                barcodeStreamRef.current = stream;
                videoRef.current.srcObject = stream;
                await videoRef.current.play();
            }

            console.log("Barcode scanner started...");
            startScanning(videoRef.current);
        } catch (error) {
            console.error("Error starting barcode scanner:", error);
        }
    };


    const stopBarcodeScanner = () => {
        if (barcodeStreamRef.current) {
            console.log("Stopping barcode scanner stream...");
            barcodeStreamRef.current.getTracks().forEach(track => {
                console.log(`Stopping track: ${track.kind}`);
                track.stop();
            });

            barcodeStreamRef.current = null;
        }

        if (videoRef.current) {
            videoRef.current.pause();
            videoRef.current.srcObject = null;
        }

        setScannerActive(false);
        setIsScanningActive(false);

        console.log("Barcode scanner fully stopped.");
    };



    const startScanning = async (videoElement) => {
        try {
            setIsScanningActive(true);

            const codeReader = new BrowserMultiFormatReader();
            console.log("Barcode scanner started...");

            const constraints = {
                video: {
                    facingMode: "user",
                    aspectRatio: 9 / 16,
                    // width: "100%",
                    // height: "100%",
                    width: { ideal: 1280 },
                    height: { ideal: 720 },
                    frameRate: { ideal: 30 },
                    objectFit: "cover",
                    autoFocus: true,
                    zoom: false,
                    autoFocus: true,
                },
            }
            const stream = await navigator.mediaDevices.getUserMedia(constraints);


            const result = await codeReader.decodeOnceFromStream(stream, videoElement);

            if (result) {
                const barcode = result.getText();
                console.log("Scanned Barcode:", barcode);

                if (scannedBarcodes.has(barcode)) {
                    console.log("Duplicate barcode detected, ignoring:", barcode);
                    alert("⚠️ Duplicate barcode detected, ignoring\n refresh.");
                    return;
                }

                setScannedBarcode(barcode);
                setScannedBarcodes((prev) => new Set(prev).add(barcode));


                const { lensId, groupId, lensName } = await getLensIdFromBarcode(barcode)
                console.log("lensId:", lensId, "groupId:", groupId);

                if (!lensId) {
                    alert("❌ No matching lens found for scanned barcode");
                    return;
                }

                // ✅ Do whatever you want now
                console.log("Matched Lens ID:", lensId);
                console.log("Group ID:", groupId);
                console.log("Lens Name:", lensName);



                const finalLensId = lensId || DEFAULT_LENS_ID;
                const finalGroupId = groupId || null;
                const finalBarcode = barcode || null;

                // const url = `/snapchatlens?barcode=${barcode}&lensId=${lensId}&groupId=${groupId}`;

                const url = `/snapchatlens/${lensId}/${groupId}/${barcode}`;


                // const matchedLens = barcodeLensMapping.find((item) => item.barcode === barcode);
                // const lensId = matchedLens ? matchedLens.lensId : DEFAULT_LENS_ID;

                window.open(url, "_self");
                // window.location.href = `/lens?lensId=${lensId}`;
            }
        } catch (error) {
            // console.error("🚨 Barcode scan error:", error);
            // alert("⚠️Barcode scanning failed. Please try again.");
        }
    };




    return (
        <>
            <div>
                {!userInteracted && (
                    <button
                        onClick={() => {
                            setUserInteracted(true);
                            startScanning();
                            startBarcodeScanner();
                        }}
                        style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            padding: "10px 20px",
                            fontSize: "15px",
                            zIndex: 10,
                        }}
                    >
                        Start Scanning
                    </button>
                )}
            </div>

            {scannerActive && (
                <>
                    <div
                        style={{
                            position: "relative",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            height: "100%",
                        }}
                    >
                        <p
                            style={{
                                position: "absolute",
                                top: "10px",
                                left: "50%",
                                transform: "translateX(-50%)",
                                padding: "10px 20px",
                                fontSize: "15px",
                                background: "rgba(0, 0, 0, 0.7)",
                                color: "white",
                                border: "none",
                                borderRadius: "10px",
                                // cursor: "pointer",
                                fontWeight: "700",
                                zIndex: 10,
                            }}
                        >
                            Barcode Scanning...
                        </p>
                        <video
                            ref={videoRef}
                            playsInline
                            muted
                            autoPlay
                            style={{
                                width: "100%",
                                height: "100%",
                                aspectRatio: 9 / 16,
                                // aspectRatio: 16 / 9,
                                objectFit: "cover",
                                // transform: "scaleX(-1)",
                                // borderRadius: "20px",
                            }}
                        />

                    </div>
                    <h4 style={{
                        position: "relative",
                        top: "1px",
                        left: "27%",
                        marginTop: "1px"
                    }}>
                        {/* Previous Scanned barcode: {scannedBarcode} */}
                    </h4>
                </>
            )}
        </>
    );

};


export default BarcodeSnapScanner_2;
